import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Footer from '../components/Footer';
import axios from 'axios';

const Apply = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    contact: '',
    address: '',
    profile: ''
  });
  
  const [resume, setResume] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: '', type: '' });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
    
    if (file && allowedTypes.includes(file.type)) {
      setResume(file);
      setMessage({ text: '', type: '' });
    } else {
      setMessage({ text: 'Please upload PDF, JPG, JPEG, or PNG file only', type: 'error' });
      e.target.value = '';
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.name || !formData.email || !formData.contact || !formData.address || !formData.profile || !resume) {
      setMessage({ text: 'Please fill all fields and upload your CV', type: 'error' });
      return;
    }

    setLoading(true);
    
    const data = new FormData();
    data.append('name', formData.name);
    data.append('email', formData.email);
    data.append('contact', formData.contact);
    data.append('address', formData.address);
    data.append('profile', formData.profile);
    data.append('resume', resume);

    try {
      const response = await axios.post('https://theagencybazaar.com/api/apply', data, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      
      if (response.data.success) {
        setMessage({ text: 'Application submitted successfully!', type: 'success' });
        // Reset form
        setFormData({ name: '', email: '', contact: '', address: '', profile: '' });
        setResume(null);
        document.getElementById('resumeInput').value = '';
      } else {
        setMessage({ text: response.data.message || 'Submission failed', type: 'error' });
      }
    } catch (error) {
      console.error('Error details:', error);
      if (error.response) {
        // Server responded with error
        setMessage({ text: error.response.data.message || 'Server error. Please try again.', type: 'error' });
      } else if (error.request) {
        // Request was made but no response
        setMessage({ text: 'Cannot connect to server. Please check if backend is running.', type: 'error' });
      } else {
        setMessage({ text: 'Error submitting application. Please try again.', type: 'error' });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <nav aria-label="breadcrumb" className="mt-5 d-flex justify-content-center">
        <ol className="breadcrumb mb-0">
          <li className="breadcrumb-item">
            <a href="/">Home</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Apply Now
          </li>
        </ol>
      </nav><br/>

      <div className="container my-5">
        <div className="row justify-content-center">
          <div className="col-md-8 col-lg-7">
            <div className="card shadow-lg border-0 rounded-4">
              <div className="card-header bg-primary text-white text-center rounded-top-4 py-4">
                <h2 className="mb-0">Apply Now</h2>
                <p className="mb-0 mt-2">Join Our Team at Agency Bazaar</p>
              </div>
              <div className="card-body p-4">
                {message.text && (
                  <div className={`alert alert-${message.type === 'success' ? 'success' : 'danger'} alert-dismissible fade show`} role="alert">
                    {message.text}
                    <button type="button" className="btn-close" onClick={() => setMessage({ text: '', type: '' })}></button>
                  </div>
                )}

                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label className="form-label fw-bold">Full Name *</label>
                    <input
                      type="text"
                      className="form-control form-control-lg"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      placeholder="Enter your full name"
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label fw-bold">Email Address *</label>
                    <input
                      type="email"
                      className="form-control form-control-lg"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      placeholder="Enter your email"
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label fw-bold">Contact Number *</label>
                    <input
                      type="tel"
                      className="form-control form-control-lg"
                      name="contact"
                      value={formData.contact}
                      onChange={handleInputChange}
                      placeholder="Enter your mobile number"
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label fw-bold">Address *</label>
                    <textarea
                      className="form-control"
                      name="address"
                      rows="3"
                      value={formData.address}
                      onChange={handleInputChange}
                      placeholder="Enter your complete address"
                      required
                    ></textarea>
                  </div>

                  <div className="mb-3">
                    <label className="form-label fw-bold">Select Profile *</label>
                    <select
                      className="form-select form-select-lg"
                      name="profile"
                      value={formData.profile}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Select a profile</option>
                      <option value="Insurance Advisor">Insurance Advisor</option>
                      <option value="POS Agent">POS Agent</option>
                      <option value="Branch Manager">Branch Manager</option>
                      <option value="Sales Executive">Sales Executive</option>
                      <option value="Telecaller"> Telecaller</option>
                      <option value="Marketing Executive">Marketing Executive</option>
                      <option value="Business Development Manager">Business Development Manager</option>
                    </select>
                  </div>

                  <div className="mb-4">
                    <label className="form-label fw-bold">Upload CV/Resume *</label>
                    <input
                      type="file"
                      id="resumeInput"
                      className="form-control"
                      onChange={handleFileChange}
                      accept=".pdf,.jpg,.jpeg,.png"
                      required
                    />
                    <small className="text-muted">Supported formats: PDF, JPG, JPEG, PNG (Max 5MB)</small>
                  </div>

                  <button 
                    type="submit" 
                    className="btn btn-primary btn-lg w-100 rounded-pill"
                    disabled={loading}
                  >
                    {loading ? 'Submitting...' : 'Submit Application →'}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    
      <Footer/>
    </>
  );
};

export default Apply;


